import { createApp } from 'vue'

import App from './App.vue'
import { setTelegramInitData } from './api'
import './styles.css'
import { initializeTelegramMiniApp } from './telegram'

const miniApp = initializeTelegramMiniApp()
setTelegramInitData(miniApp?.initData ?? '')
createApp(App).mount('#app')
